import React from 'react';
import { IoSchool, IoSearch, IoShieldCheckmark } from 'react-icons/io5';
import AnimatedSection from '../ui/AnimatedSection';

const SocialImpact = () => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="social-impact" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Social Impact</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We're committed to addressing the world's most pressing challenges.
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          <AnimatedSection delay={0.1}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10 h-full flex flex-col">
              <div className="mb-6 text-blue-400 flex justify-center">
                <IoSchool className="text-6xl" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">Ramwin Academy</h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Empowering individuals through accessible learning resources, totally for free.
              </p>
              <a
                href="#about"
                onClick={(e) => scrollToSection(e, 'about')}
                className="text-blue-400 hover:text-blue-300 font-semibold inline-flex items-center mt-auto"
              >
                Start Learning →
              </a>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10 h-full flex flex-col">
              <div className="mb-6 text-blue-400 flex justify-center">
                <IoSearch className="text-6xl" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">Free Resources</h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Access comprehensive guides and insights to make your projects better.
              </p>
              <a
                href="#services"
                onClick={(e) => scrollToSection(e, 'services')}
                className="text-blue-400 hover:text-blue-300 font-semibold inline-flex items-center mt-auto"
              >
                Get started →
              </a>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.3}>
            <div className="dark-card rounded-xl transition-all duration-300 p-8 text-center relative z-10 h-full flex flex-col">
              <div className="mb-6 text-blue-400 flex justify-center">
                <IoShieldCheckmark className="text-6xl" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">Free Security Scans</h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                Get a comprehensive security assessment of your applications.
              </p>
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, 'contact')}
                className="text-blue-400 hover:text-blue-300 font-semibold inline-flex items-center mt-auto"
              >
                Scan now →
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default SocialImpact;

